import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react"

import gdprLogo from 'assets/images/mrg/badge_gdprCompliant.jpg';
import privacyShieldLogo from 'assets/images/mrg/badge_privacyShield.png';
import wbencLogo from 'assets/images/mrg/badge_wbenc_2022a.png';
import { IGlobal } from "config/config.interface";
import { faFacebook, faLinkedinIn, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

export interface IAppFooterProps {
    isFixed?: boolean;
    isCompact?: boolean;
}

export default function AppFooter(props: IAppFooterProps) {
    const globalConfig = (global as any as IGlobal);
    const translations = {
        footer_imgAlt_gdpr: '',
        footer_imgAlt_privacyShield: '',

        footer_imgAlt_wbenc: '',
        footer_link_privacy: 'Privacy Policy',
        footer_link_knowledgeBase: 'Knowledge Base'
    }

    return (
        <>
            <div id="footer-container" className={`footer-container mrg-bg mt-0 ${props.isFixed ? ' fixed-bottom ' : ''} ${props.isCompact ? " compact " : ""}`}>
                <div className="footer-inside">
                    <div id="footer-left">
                        {!props.isCompact &&
                            <>
                                <a href="https://gdpr.eu" target="_blank" rel="noopener noreferrer">
                                    <img src={gdprLogo} alt={translations.footer_imgAlt_gdpr} className="gdpr" />
                                </a>
                                <a href="https://www.privacyshield.gov/participant?id=a2zt00000008SAkAAM&status=Active" target="_blank" rel="noopener noreferrer">
                                    <img src={privacyShieldLogo} alt={translations.footer_imgAlt_privacyShield} className="privacy" />
                                </a>
                                <a href="https://www.wbenc.org" target="_blank" rel="noopener noreferrer">
                                    <img src={wbencLogo} alt={translations.footer_imgAlt_wbenc} className="wbenc" />
                                </a>
                            </>
                        }
                    </div>

                    <div id="footer-center">
                        <div className="socialMediaBlock">
                            <a href="https://www.facebook.com/MRGassessments/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                            <a href="https://www.linkedin.com/company/mrg-assessments" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                            <a href="https://twitter.com/MRG_Assessments" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>
                            <a href="https://www.youtube.com/user/MRGeducation" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faYoutube} />
                            </a>
                        </div>
                        <div className="linksBlock">
                            <a href={globalConfig.config.URL_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">{translations.footer_link_privacy}
                            </a> | <a href="https://www.mrg.com" target="_blank" rel="noopener noreferrer">MRG.com
                            </a> | <a href="https://mrg.helpjuice.com" target="_blank" rel="noopener noreferrer">{translations.footer_link_knowledgeBase}</a>
                        </div>
                    </div>

                    <div id="footer-right">
                        &copy; {new Date().getFullYear()} Management Research Group, Inc.
                    </div>

                </div>{/* /.footer-inside */}
            </div>{/* /#footer-container */}
        </>
    )
}
